import p1 from '../assets/img/p-1.jpg'
import p2 from '../assets/img/p-2.jpg'
import p3 from '../assets/img/p-3.jpg'
import p4 from '../assets/img/p-4.jpg'
import p5 from '../assets/img/p-5.jpg'
import p6 from '../assets/img/p-6.jpg'
import p7 from '../assets/img/p-7.jpg'
import p8 from '../assets/img/p-8.jpg'
import p9 from '../assets/img/p-9.jpg'
import p10 from '../assets/img/p-10.jpg'
import p11 from '../assets/img/p-11.jpg'
import p12 from '../assets/img/p-12.jpg'
import p13 from '../assets/img/p-13.jpg'
import p14 from '../assets/img/p-14.jpg'
import p19 from '../assets/img/p-19.jpg'
import p20 from '../assets/img/p-20.jpg'
import p21 from '../assets/img/p-21.jpg'
import p22 from '../assets/img/p-22.jpg'
import p23 from '../assets/img/p-23.jpg'
import p24 from '../assets/img/p-24.jpg'

import c1 from '../assets/img/c-1.png'
import c2 from '../assets/img/c-2.png'
import c3 from '../assets/img/c-3.png'
import c4 from '../assets/img/c-4.png'
import c5 from '../assets/img/c-5.png'
import c6 from '../assets/img/c-6.png'
import c7 from '../assets/img/c-7.png'
import c8 from '../assets/img/c-8.png'

import ct1 from '../assets/img/ct-1.png'
import ct2 from '../assets/img/ct-2.png'
import ct3 from '../assets/img/ct-3.png'
import ct4 from '../assets/img/ct-4.png'
import ct5 from '../assets/img/ct-5.png'
import ct6 from '../assets/img/ct-6.png'
import ct7 from '../assets/img/ct-7.png'
import ct8 from '../assets/img/ct-8.png'
import ct9 from '../assets/img/ct-9.png'
import ct10 from '../assets/img/ct-10.png'
import ct11 from '../assets/img/ct-11.png'
import ct12 from '../assets/img/ct-12.png'
import ct13 from '../assets/img/ct-13.png'

import work1 from '../assets/img/svg/work-1.svg'
import work2 from '../assets/img/svg/work-2.svg'
import work3 from '../assets/img/svg/work-3.svg'

import client1 from '../assets/img/user-1.jpg'
import client2 from '../assets/img/user-2.jpg'
import client3 from '../assets/img/user-3.jpg'
import client4 from '../assets/img/user-4.jpg'
import client5 from '../assets/img/user-5.jpg'
import client6 from '../assets/img/user-6.jpg'
import client7 from '../assets/img/user-7.jpg'
import client8 from '../assets/img/user-8.jpg'

import agency1 from '../assets/img/ag-1.png'
import agency2 from '../assets/img/ag-2.png'
import agency3 from '../assets/img/ag-3.png'
import agency4 from '../assets/img/ag-4.png'
import agency5 from '../assets/img/ag-5.png'
import agency6 from '../assets/img/ag-6.png'
import agency7 from '../assets/img/ag-7.png'
import agency8 from '../assets/img/ag-8.png'

import tour1 from '../assets/img/tour-1.jpg'
import tour2 from '../assets/img/tour-2.jpg'
import tour3 from '../assets/img/tour-3.jpg'
import tour4 from '../assets/img/tour-4.jpg'
import tour5 from '../assets/img/tour-5.jpg'

export const navProperty = [
    {
        image: p1,
        title: 'Loss vengel New Apartment',
        loction: 'Sans Fransico',
        tag: 'For Sale',
        value: '$4,240'
    },
    {
        image: p2,
        title: 'Montreal Quriqe Apartment',
        loction: 'Liverpool, London',
        tag: 'For Rent',
        value: '$7,380'
    },
    {
        image: p3,
        title: 'Curmic Studio For Office',
        loction: 'Montreal, Canada',
        tag: 'For Buy',
        value: '$8,730'
    },
    {
        image: p4,
        title: 'Montreal Quebec City',
        loction: 'Sreek View, New York',
        tag: 'For Rent',
        value: '$6,240'
    },
    {
        image: p5,
        title: 'Loss vengel New Apartment',
        loction: 'Sans Fransico',
        tag: 'For Sale',
        value: '$4,240'
    },
    {
        image: p6,
        title: 'Montreal Quriqe Apartment',
        loction: 'Liverpool, London',
        tag: 'For Rent',
        value: '$7,380'
    },
    {
        image: p7,
        title: 'Curmic Studio For Office',
        loction: 'Montreal, Canada',
        tag: 'For Buy',
        value: '$8,730'
    },
    {
        image: p8,
        title: 'Montreal Quebec City',
        loction: 'Sreek View, New York',
        tag: 'For Rent',
        value: '$6,240'
    },
]

export const propertyData = [
    {
        id: 1,
        image: [p1, p9, p10],
        tag: ['Verified'],
        tag2: 'For Rent',
        type: 'Apartment',
        name: 'The Green Canton Chrysler',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$80,000'
    },
    {
        id: 2,
        image: [p2, p6, p8],
        tag: ['SuperAgent'],
        tag2: 'For Sell',
        type: 'House',
        name: 'Purple Flatiron House',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$67,000'
    },
    {
        id: 3,
        image: [p3, p5, p7],
        tag: ['Verified', 'New'],
        tag2: 'For Rent',
        type: 'Building',
        name: 'The Green Canton Chrysler',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$92,500'
    },
    {
        id: 4,
        image: [p4, p6, p9],
        tag: ['SuperAgent'],
        tag2: 'For Sell',
        type: 'Condos',
        name: 'The Red Freedom Tower',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$89,000'
    },
    {
        id: 5,
        image: [p5, p12, p13],
        tag: ['Verified', 'New'],
        tag2: 'For Rent',
        type: 'Villa',
        name: 'The Donald Dwelling',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$88,000'
    },
    {
        id: 6,
        image: [p6, p7, p11],
        tag: ['SuperAgent'],
        tag2: 'For Sell',
        type: 'Building',
        name: 'Red Tiny Hearst Castle',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$10,50000'
    },
    {
        id: 7,
        image: [p22, p3, p5],
        tag: ['SuperAgent'],
        tag2: 'For Sell',
        type: 'Condos',
        name: 'The Red Freedom Tower',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$89,000'
    },
    {
        id: 8,
        image: [p12, p13, p14],
        tag: ['Verified', 'New'],
        tag2: 'For Rent',
        type: 'Villa',
        name: 'The Donald Dwelling',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$88,000'
    },
    {
        id: 9,
        image: [p7, p8, p12],
        tag: ['SuperAgent'],
        tag2: 'For Sell',
        type: 'Building',
        name: 'Red Tiny Hearst Castle',
        loction: '210 Zirak Road, Canada',
        size: '3BHK',
        beds: '3 Beds',
        sqft: '1800 SQFT',
        value: '$10,50000'
    },
]

export const workData = [
    {
        image: work1,
        title: 'Evaluate Property',
        desc: 'Cicero famously orated against his political opponent Lucius Sergius Catilina. Occasionally the first Oration against Catiline is taken specimens.',
        bg: 'f-light-success'
    },
    {
        image: work2,
        title: 'Meet Your Agent',
        desc: 'Cicero famously orated against his political opponent Lucius Sergius Catilina. Occasionally the first Oration against Catiline is taken specimens.',
        bg: 'f-light-warning'
    },
    {
        image: work3,
        title: 'Close The Deal',
        desc: 'Cicero famously orated against his political opponent Lucius Sergius Catilina. Occasionally the first Oration against Catiline is taken specimens.',
        bg: 'f-light-purple'
    },
]

export const bestLoction = [
    {
        image: c1,
        location: 'San Francisco, California',
        properties: '95 Properties'
    },
    {
        image: c2,
        location: 'Dunao, California',
        properties: '95 Properties'
    },
    {
        image: c3,
        location: 'Liverpool, London',
        properties: '95 Properties'
    },
    {
        image: c4,
        location: 'San Francisco, New York',
        properties: '95 Properties'
    },
    {
        image: c5,
        location: 'New Orleans, Louisiana',
        properties: '95 Properties'
    },
    {
        image: c6,
        location: 'Los Angeles',
        properties: '95 Properties'
    },
    {
        image: c7,
        location: 'Dubai, UAE',
        properties: '95 Properties'
    },
    {
        image: c8,
        location: 'Dhaka, UAE',
        properties: '95 Properties'
    },
]

export const clientData = [
    {
        image: client1,
        quote: 'bg-primary',
        desc: 'Cicero famously orated against his political opponent Lucius Sergius Catilina. Occasionally the first Oration against Catiline is taken specimens.',
        name: 'Adam Williams',
        position: 'CEO Of Microwoft'
    },
    {
        image: client2,
        quote: 'bg-success',
        desc: 'Cicero famously orated against his political opponent Lucius Sergius Catilina. Occasionally the first Oration against Catiline is taken specimens.',
        name: 'Retha Deowalim',
        position: 'CEO Of Apple'
    },
    {
        image: client3,
        quote: 'bg-purple',
        desc: 'Cicero famously orated against his political opponent Lucius Sergius Catilina. Occasionally the first Oration against Catiline is taken specimens.',
        name: 'Sam J. Wasim',
        position: 'Pio Founder'
    },
    {
        image: client4,
        quote: 'bg-seegreen',
        desc: 'Cicero famously orated against his political opponent Lucius Sergius Catilina. Occasionally the first Oration against Catiline is taken specimens.',
        name: 'Usan Gulwarm',
        position: 'CEO Of Facewarm'
    },
    {
        image: client5,
        quote: 'bg-danger',
        desc: 'Cicero famously orated against his political opponent Lucius Sergius Catilina. Occasionally the first Oration against Catiline is taken specimens.',
        name: 'Shilpa Shethy',
        position: 'CEO Of Zapple'
    },
]

export const pricingData = [
    {
        value: 10,
        title: 'Basic Package',
        feature: ['One Ad', 'Contact With Space Provider', '45 day Ad', 'Email Support', 'Up to 15 Photos per Ad'],
        btn: 'btn btn-light-primary rounded full-width',
        bg: 'bg-dark',
        titleText: 'text-info'
    },
    // {
    //     value: 45,
    //     title: 'STANDARD PACKAGE',
    //     feature: ['Five Ads', 'Contact With Space Provider', '45 day Ad', 'Email Support', 'Up to 10 Photos per Ad'],
    //     btn: 'btn btn-dark rounded full-width',
    //     bg: 'bg-primary',
    //     titleText: 'text-light'
    // },
    // {
    //     value: 199,
    //     title: 'PLATINUM PACKAGE',  
    //     feature: ['Ten Ads', 'Contact With Space Provider', '45 day Ad', 'Email Support', 'Up to 10 Photos per Ad'],
    //     btn: 'btn btn-light-primary rounded full-width',
    //     bg: 'bg-dark',
    //     titleText: 'text-info'
    // },
]

export const achievementData = [
    {
        title: 'Completed Property',
        value: 615,
        symbol: 'K'
    },
    {
        title: 'Property Sales',
        value: 210,
        symbol: 'K'
    },
    {
        title: 'Apartment Rent',
        value: 916,
        symbol: '+'
    },
    {
        title: 'Happy Clients',
        value: 150,
        symbol: '+'
    },
]

export const teamData = [
    {
        image: client1,
        name: 'James N. Green',
        property: '117 Properties',
        call: '1234567859',
        review: '42 Reviews'
    },
    {
        image: client2,
        name: 'Seema Gauranki',
        property: '46 Properties',
        call: '1234567859',
        review: '33 Reviews'
    },
    {
        image: client3,
        name: 'Adam Walcorn',
        property: '38 Properties',
        call: '1234567859',
        review: '16 Reviews'
    },
    {
        image: client4,
        name: 'Jasmin Khatri',
        property: '51 Properties',
        call: '1234567859',
        review: '28 Reviews'
    },
    {
        image: client5,
        name: 'Rudra K. Mathan',
        property: '75 Properties',
        call: '1234567859',
        review: '52 Reviews'
    },
    {
        image: client6,
        name: 'Niharika Muthurk',
        property: '15 Properties',
        call: '1234567859',
        review: '46 Reviews'
    },
    {
        image: client7,
        name: 'Grack Chappel',
        property: '17 Properties',
        call: '1234567859',
        review: '102 Reviews'
    },
    {
        image: client8,
        name: 'Nikita Rajaswi',
        property: '62 Properties',
        call: '1234567859',
        review: '18 Reviews'
    },
]

export const blogData = [
    {
        id: 1,
        image: p19,
        date: '13th Sept 2025',
        title: 'Why people choose listio for own properties',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id: 2,
        image: p20,
        date: '29th Nov 2025',
        title: 'List of benifits and impressive Resido services',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id: 3,
        image: p21,
        date: '29th Dec 2025',
        title: 'What people says about listio properties',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id: 4,
        image: p22,
        date: '13th March 2025',
        title: 'Why people choose listio for own properties',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id: 5,
        image: p23,
        date: '5th May 2025',
        title: 'List of benifits and impressive Resido services',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
    {
        id: 6,
        image: p24,
        date: '19th June 2025',
        title: 'What people says about listio properties',
        desc: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.'
    },
]

export const explorePlace = [
    {
        image: ct1,
        loction: 'North America',
        property: '43 Properties'
    },
    {
        image: ct2,
        loction: 'South America',
        property: '35 Properties'
    },
    {
        image: ct3,
        loction: 'Asia',
        property: '42 Properties'
    },
    {
        image: ct4,
        loction: 'Europe',
        property: '47 Properties'
    },
    {
        image: ct5,
        loction: 'Africa',
        property: '17 Properties'
    },
    {
        image: ct6,
        loction: 'Australia/New Zealand',
        property: '37 Properties'
    }
]

export const propertyType = [
    {
        icon: 'fa-solid fa-house-laptop',
        name: 'Other Space',
        property: '12 Properties'
    },
    {
        icon: 'fa-solid fa-building',
        name: 'Multifamily',
        property: '16 Properties'
    },
    {
        icon: 'fa-solid fa-building-shield',
        name: 'Office Space',
        property: '22 Properties'
    },
    {
        icon: 'fa-solid fa-synagogue',
        name: 'Restaurant Space',
        property: '18 Properties'
    },
    {
        icon: 'fa-solid fa-mosque',
        name: 'Special Purpose',
        property: '42 Properties'
    },
    {
        icon: 'fa-solid fa-tree-city',
        name: 'Warehouse Space',
        property: '63 Properties'
    },
    {
        icon: 'fa-solid fa-house',
        name: 'Residential',
        property: '12 Properties'
    },
    {
        icon: 'fa-solid fa-landmark-dome',
        name: 'Single Tenant office',
        property: '16 Properties'
    },
    {
        icon: 'fa-solid fa-city',
        name: 'Industrial Space',
        property: '19 Properties'
    },
    {
        icon: 'fa-solid fa-warehouse',
        name: 'Flex Space',
        property: '17 Properties'
    },
    {
        icon: 'fa-solid fa-shop-lock',
        name: 'Retail Space',
        property: '10 Properties'
    },
    {
        icon: 'fa-solid fa-building-columns',
        name: 'Single Tenant Retail',
        property: '31 Properties'
    },
]

export const categoriesData = [
    {
        icon: 'fa-solid fa-house',
        title: 'Private House',
        subTitle: '12 Properties',
        bg: 'bg-light-success text-success'
    },
    {
        icon: 'fa-solid fa-house',
        title: 'Apartment',
        subTitle: '16 Properties',
        bg: 'bg-light-warning text-warning'
    },
    {
        icon: 'fa-solid fa-building-shield',
        title: 'Townhouse',
        subTitle: '22 Properties',
        bg: 'bg-light-danger text-danger'
    },
    {
        icon: 'fa-solid fa-synagogue',
        title: 'Villa',
        subTitle: '18 Properties',
        bg: 'bg-light-info text-primary'
    },
    {
        icon: 'fa-solid fa-mosque',
        title: 'Offices',
        subTitle: '42 Properties',
        bg: 'bg-light-success text-success'
    },
    {
        icon: 'fa-solid fa-tree-city',
        title: 'Warehouses',
        subTitle: '63 Properties',
        bg: 'bg-light-danger text-danger'
    },
]

export const agentData = [
    {
        id: 1,
        image: client1,
        name: 'James N. Green',
        property: '117 Properties',
        call: '1234567859',
        review: '42 Reviews'
    },
    {
        id: 2,
        image: client2,
        name: 'Seema Gauranki',
        property: '46 Properties',
        call: '1234567859',
        review: '33 Reviews'
    },
    {
        id: 3,
        image: client3,
        name: 'Adam Walcorn',
        property: '38 Properties',
        call: '1234567859',
        review: '16 Reviews'
    },
    {
        id: 4,
        image: client4,
        name: 'Jasmin Khatri',
        property: '51 Properties',
        call: '1234567859',
        review: '28 Reviews'
    },
    {
        id: 5,
        image: client5,
        name: 'Rudra K. Mathan',
        property: '75 Properties',
        call: '1234567859',
        review: '52 Reviews'
    },
    {
        id: 6,
        image: client6,
        name: 'Niharika Muthurk',
        property: '15 Properties',
        call: '1234567859',
        review: '46 Reviews'
    },
    {
        id: 7,
        image: client7,
        name: 'Grack Chappel',
        property: '17 Properties',
        call: '1234567859',
        review: '102 Reviews'
    },
    {
        id: 8,
        image: client8,
        name: 'Nikita Rajaswi',
        property: '62 Properties',
        call: '1234567859',
        review: '42 Reviews'
    },
    {
        id: 9,
        image: client1,
        name: 'Rudra K. Mathan',
        property: '75 Properties',
        call: '1234567859',
        review: '52 Reviews'
    },
    {
        id: 10,
        image: client2,
        name: 'Niharika Muthurk',
        property: '15 Properties',
        call: '1234567859',
        review: '46 Reviews'
    },
    {
        id: 11,
        image: client3,
        name: 'Grack Chappel',
        property: '17 Properties',
        call: '1234567859',
        review: '102 Reviews'
    },
    {
        id: 12,
        image: client4,
        name: 'Nikita Rajaswi',
        property: '62 Properties',
        call: '1234567859',
        review: '18 Reviews'
    },
]
export const agentInfo = [
    {
        title: 'Ceo',
        subTitle: 'Mr. Adam Vilawo',
    },
    {
        title: 'Email',
        subTitle: 'Isvali@gmail.com',
    },
    {
        title: 'Phone',
        subTitle: '+91 235 658 4758',
    },
    {
        title: 'Skype',
        subTitle: 'isva24lia',
    },
    {
        title: 'Address',
        subTitle: '320, Near Iswar',
    },
    {
        title: 'City',
        subTitle: 'New York',
    },
    {
        title: 'Country',
        subTitle: 'United State',
    },
    {
        title: 'Stab',
        subTitle: '2007',
    },
]

export const agencyData = [
    {
        id: 1,
        image: agency1,
        agent: '5 Agents',
        name: 'Green villa',
        property: '117 Properties'
    },
    {
        id: 2,
        image: agency2,
        agent: '4 Agents',
        name: 'Modern house',
        property: '76 Properties'
    },
    {
        id: 3,
        image: agency3,
        agent: '3 Agents',
        name: 'Royal Estate',
        property: '53 Properties'
    },
    {
        id: 4,
        image: agency4,
        agent: '4 Agents',
        name: 'Royal Green',
        property: '14 Properties'
    },
    {
        id: 5,
        image: agency5,
        agent: '10 Agents',
        name: 'Muskaan Estate',
        property: '63 Properties'
    },
    {
        id: 6,
        image: agency6,
        agent: '9 Agents',
        name: 'Red House',
        property: '18 Properties'
    },
    {
        id: 7,
        image: agency7,
        agent: '8 Agents',
        name: 'Green Villa',
        property: '69 Properties'
    },
    {
        id: 8,
        image: agency8,
        agent: '7 Agents',
        name: 'Estate City',
        property: '42 Properties'
    },
    {
        id: 9,
        image: agency1,
        agent: '3 Agents',
        name: 'House Design',
        property: '31 Properties'
    },
    {
        id: 10,
        image: agency2,
        agent: '2 Agents',
        name: 'Jumil Estate',
        property: '25 Properties'
    },
    {
        id: 11,
        image: agency3,
        agent: '5 Agents',
        name: 'House Stock',
        property: '18 Properties'
    },
    {
        id: 12,
        image: agency4,
        agent: '6 Agents',
        name: 'Ran Estate',
        property: '63 Properties'
    },
]

export const blogCategories = [
    {
        title: 'Lifestyle',
        value: '09'
    },
    {
        title: 'Travel',
        value: '12'
    },
    {
        title: 'Fashion',
        value: '19'
    },
    {
        title: 'Branding',
        value: '17'
    },
    {
        title: 'Music',
        value: '10'
    },
]

export const trendingPost = [
    {
        image: tour1,
        title: 'Alonso Kelina Falao Asiano Pero',
        time: '10 Min ago'
    },
    {
        image: tour2,
        title: 'It is a long established fact that a reader',
        time: '10 Min ago'
    },
    {
        image: tour3,
        title: 'Many desktop publish packages and web',
        time: '10 Min ago'
    },
    {
        image: tour4,
        title: 'Various versions have evolved over the years',
        time: '10 Min ago'
    },
    {
        image: tour5,
        title: 'Photo booth anim 8-bit PBR 3 wolf moon.',
        time: '10 Min ago'
    },
]

export const tagCloud = [
    'Lifestyle', 'Travel', 'Fashion', 'Branding', 'Music'
]

export const faqAbout = [
    {
        icon: 'fa-solid fa-basket-shopping text-primary',
        title: 'Contact Sales',
        subTitle: 'sales@rikadahelp.co.uk',
        subTitle2: '+01 215 245 6258',
    },
    {
        icon: 'fa-solid fa-user-tie text-primary',
        title: 'Contact Sales',
        subTitle: 'sales@rikadahelp.co.uk',
        subTitle2: '+01 215 245 6258',
    },
    {
        icon: 'fa-solid fa-comments text-primary',
        title: 'Start Live Chat',
        subTitle: '+01 215 245 6258k',
        subTitle2: 'Live Chat',
    },
]

export const faqData = [
    {
        id: 1,
        title: 'How To Install Rikada Theme?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id: 2,
        title: 'What is main Requirements For Rikada?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id: 3,
        title: 'Why Choose Rikada Theme?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
]
export const faq2 = [
    {
        id: 1,
        title: 'May I Request For Refund?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id: 2,
        title: 'May I Get Any Offer in Future?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id: 3,
        title: ' How Much Time It will Take For refund?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
]
export const faq3 = [
    {
        id: 1,
        title: 'How To Upgrade Rikada Theme?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id: 2,
        title: 'Rikada available for WordPress Version?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
    {
        id: 3,
        title: 'Why We need to upgrade Rikada?',
        desc: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.`
    },
]